@if (allowanceEntity$ | async) {
  <snelstart-ui-details
    [config]="detailsConfig"
    [entityId]="id"
    title="{{id}}"
  >
    <snelstart-ui-details-content>
      @if (id === 'Voorschot') {
        <snelstart-venture-fiscaal-feature-voorschot></snelstart-venture-fiscaal-feature-voorschot>
      }
      @if (id === 'Aanvrager') {
        <snelstart-venture-fiscaal-feature-inkomen></snelstart-venture-fiscaal-feature-inkomen>
      }
      @if (id === 'Partner') {
        <snelstart-venture-fiscaal-feature-partner></snelstart-venture-fiscaal-feature-partner>
      }
      @if (id === 'Kinderen') {
        <snelstart-venture-fiscaal-feature-kinderen></snelstart-venture-fiscaal-feature-kinderen>
      }
      @if (id === 'Kinderopvang') {
        <snelstart-venture-fiscaal-feature-kinderopvangtoeslag></snelstart-venture-fiscaal-feature-kinderopvangtoeslag>
      }
      @if (id === 'Huurwoning') {
        <snelstart-venture-fiscaal-feature-huurtoeslag></snelstart-venture-fiscaal-feature-huurtoeslag>
      }
      @if (id === 'Berekening') {
        <snelstart-venture-fiscaal-feature-berekening></snelstart-venture-fiscaal-feature-berekening>
      }

    </snelstart-ui-details-content>

    <snelstart-ui-details-buttons>
      @if (!showButtonOpslaan(id)) {
        <snelstart-ui-button [config]="config()"
                             class="me-2"
                             type="primary"
        >
          Opslaan
        </snelstart-ui-button>
      }

      @if (showButtonInfo(id)) {
        <snelstart-ui-button (click)="this.showDialogInfo()"
                             type="secondary">
          Toelichting
        </snelstart-ui-button>
      }

    </snelstart-ui-details-buttons>

    <snelstart-ui-dialog-definition [(visible)]="dialogInfoVisible" id="toelIB"
                                    size="lg"
                                    title="Toelichting bij '{{id}}'">
      <snelstart-ui-dialog-body>

        @if (id === 'Aanvrager') {
          <snelstart-venture-fiscaal-feature-tekst-aanvrager></snelstart-venture-fiscaal-feature-tekst-aanvrager>
        }
        @if (id === 'Partner') {
          <snelstart-venture-fiscaal-feature-tekst-partner></snelstart-venture-fiscaal-feature-tekst-partner>
        }
        @if (id === 'Kinderen') {
          <snelstart-venture-fiscaal-feature-tekst-kinderen></snelstart-venture-fiscaal-feature-tekst-kinderen>
        }
        @if (id === 'Kinderopvang') {
          <snelstart-venture-fiscaal-feature-tekst-kinderopvang></snelstart-venture-fiscaal-feature-tekst-kinderopvang>
        }
        @if (id === 'Huurwoning') {
          <snelstart-venture-fiscaal-feature-tekst-huurtoeslag></snelstart-venture-fiscaal-feature-tekst-huurtoeslag>
        }

        <!-- algemene informatie van Belastingdienst-->
        <div class="accordion" id="accordionExample" style="margin-top: -25px;">

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingMeer">
              <button aria-controls="collapseMeer" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapseMeer" data-bs-toggle="collapse" type="button">
                Meer informatie over toeslagen
              </button>
            </h2>
            <div aria-labelledby="headingMeer" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
                 id="collapseMeer">
              <div class="accordion-body">
                De Belastingdienst heeft online uitgebreide informatie over de
                toeslagen beschikbaar.
                <div class="space20"></div>
                <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small"
                                     type="secondary">
                  <a
                    href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/belastingdienst/prive/toeslagen/hoe_werken_toeslagen/"
                    target="_blank">
                    Uitgebreidere informatie toeslagen
                  </a>

                </snelstart-ui-button>
              </div>
            </div>
          </div>
        </div>

        <div class="accordion" id="accordionPdf">

          <div class="accordion-item">
            <h2 class="accordion-header" id="headingPdf">
              <button aria-controls="collapsePdf" aria-expanded="false" class="accordion-button collapsed"
                      data-bs-target="#collapsePdf" data-bs-toggle="collapse" type="button">
                Toeslagenkaart
              </button>
            </h2>
            <div aria-labelledby="headingPdf" class="accordion-collapse collapse" data-bs-parent="#accordionPdf"
                 id="collapsePdf">
              <div class="accordion-body">
                Bekijk de Toeslagenkaart {{ this.allowanceEntity.year }} van de Belastingdienst voor alle belangrijke
                bedragen voor de toeslagen.
                <div class="space20"></div>
                <snelstart-ui-button iconRight="arrow-up-right-from-square" size="small"
                                     type="secondary">
                  <a href="https://download.belastingdienst.nl/toeslagen/docs/toeslagenkaart_2025_tg7101z51pl.pdf"
                     target="_blank">
                    Toeslagenkaart {{ this.allowanceEntity.year }} (pdf)
                  </a>

                </snelstart-ui-button>
              </div>
            </div>
          </div>
        </div>
      </snelstart-ui-dialog-body>

      <snelstart-ui-dialog-buttons class="d-flex mt-2">
        <snelstart-ui-button btn-x icon="check" id="sluiten" type="primary">Afsluiten
        </snelstart-ui-button>
      </snelstart-ui-dialog-buttons>

    </snelstart-ui-dialog-definition>

  </snelstart-ui-details>
}
